import { ProductPurchaseOption, ProductPurchaseType } from '../productMap';
import { NewM1Data } from './IN';

export const newM1Data: NewM1Data = {
  [ProductPurchaseOption.oneTimePurchase]: {
    title: 'One Time Purchase',
    defaultProduct: ProductPurchaseType.otp_2_weeks_eu,
    directCheckout: false,
    plans: {
      [ProductPurchaseType.otp_2_weeks_eu]: {
        displayName:
          'Ultrahuman M1 Live | 2 Weeks Trial continuous glucose monitoring',
        price: 109,
        variantId: 'gid://shopify/ProductVariant/49203361284414',
        internalPid: ProductPurchaseType.otp_2_weeks_eu,
        secondaryImage: '',
        title: '2 Weeks Trial',
        subtitle1: '1 CGM Sensor',
        subtitle2: 'Delivery on purchase',
      },
      [ProductPurchaseType.otp_4_weeks_eu]: {
        displayName:
          'Ultrahuman M1 Live | 1 Month continuous glucose monitoring',
        price: 169,
        variantId: 'gid://shopify/ProductVariant/49202716934462',
        internalPid: ProductPurchaseType.otp_4_weeks_eu,
        secondaryImage: '',
        title: '4 Weeks',
        subtitle1: '2 CGM Sensors',
        subtitle2: 'Delivery on purchase',
      },
    },
  },
};

export const m1data: Record<
  string,
  Array<Record<string, string | HTMLImageElement | number>> | boolean
> = {
  taxInclusive: false,
  plans: [
    {
      displayName:
        'Ultrahuman M1 Live | 2 Weeks Trial continuous glucose monitoring',
      price: 109,
      variantId: 'gid://shopify/ProductVariant/49203361284414',
      internalPid: 'otp_2_weeks_eu',
      secondaryImage: '',
    },
    {
      displayName: 'Ultrahuman M1 Live | 1 Month continuous glucose monitoring',
      price: 169,
      variantId: 'gid://shopify/ProductVariant/49202716934462',
      internalPid: 'otp_4_weeks_eu',
      secondaryImage: '',
    },
  ],
};
